import { Link, useLocation } from 'react-router-dom';
import qs from 'qs';
import { Tabs, TabsList, TabsTrigger } from '@src/design-system/tabs';
import { Bank, UserSquare } from 'iconsax-react';
import React from 'react';
import PersonalInfo from './personal-info';
import UserBankInfo from './bank-info';

export const UserTabs = () => {
  const { search } = useLocation();

  const profileTabs = [
    {
      label: 'Personal Info',
      value: 'personalInfo',
      default: true,
      icon: <UserSquare />,
      content: <PersonalInfo />,
    },
    {
      label: 'Bank Info',
      value: 'bankInfo',
      icon: <Bank />,
      content: <UserBankInfo />,
    },
  ];

  const { tab: tabValueFromUrl } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  return (
    <Tabs className='w-full'>
      <TabsList className='px-4 h-14 shadow inset-shadow-2xs'>
        {profileTabs.map((tab) => {
          const queryString = qs.stringify({
            tab: tab.value,
          });

          const active = new Map([
            [
              (!tabValueFromUrl && tab.default) ||
                tabValueFromUrl === tab.value,
              'active',
            ],
          ]);

          return (
            <TabsTrigger
              key={tab.value}
              data-state={active.get(true)}
              value={tab.value}
              className='mt-5 px-5'
              asChild
            >
              <Link
                className='flex gap-2 items-center p-0'
                to={{ search: queryString }}
              >
                {React.cloneElement(tab.icon, {
                  variant: active.get(true) ? 'Bold' : 'Linear',
                  size: 20,
                })}
                {tab.label}
              </Link>
            </TabsTrigger>
          );
        })}
      </TabsList>

      <div className='py-4 px-6'>
        {
          profileTabs.find(
            (tab) =>
              tabValueFromUrl === tab.value || (!tabValueFromUrl && tab.default)
          )?.content
        }
      </div>
    </Tabs>
  );
};
